import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isTrackedPath, trackPageView } from '../utils/tracking';
import { trackSiteNavigation } from '../utils/siteEvents';

// O primeiro page_view sai das próprias tags no <head>; aqui cobrimos só a
// navegação interna do SPA. Comparar com o último caminho (em vez de uma flag
// de primeira renderização) evita evento duplicado em remontagem/StrictMode.
const RouteTracker: React.FC = () => {
  const { pathname, search } = useLocation();
  const path = `${pathname}${search}`;
  const lastPath = useRef(path);

  // Funil próprio: inclui a primeira página (entrada da sessão).
  useEffect(() => {
    trackSiteNavigation(pathname);
  }, [pathname]);

  useEffect(() => {
    if (path === lastPath.current) return;
    lastPath.current = path;
    if (isTrackedPath(pathname)) {
      trackPageView(path);
    }
  }, [path, pathname]);

  return null;
};

export default RouteTracker;
